"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.patch = exports.head = exports.del = exports.put = exports.post = exports.get = void 0;
const utils_1 = require("../../utils");
const isIamAuthApplicable_1 = require("../../utils/isIamAuthApplicable");
const transferHandler_1 = require("./transferHandler");
const publicHandler = (amplify, options, method) => {
    const { apiName, options: apiOptions = {}, path: apiPath } = options;
    const libraryConfigTimeout = amplify.libraryOptions?.API?.REST?.timeout?.({
        apiName,
        method,
    });
    const timeout = apiOptions?.timeout || libraryConfigTimeout || undefined;
    const publicApisAbortController = new AbortController();
    const abortSignal = publicApisAbortController.signal;
    return (0, utils_1.createCancellableOperation)(async () => {
        const url = (0, utils_1.resolveApiUrl)(amplify, apiName, apiPath, apiOptions?.queryParams);
        const libraryConfigHeaders = await amplify.libraryOptions?.API?.REST?.headers?.({
            apiName,
        });
        const { headers: invocationHeaders = {} } = apiOptions;
        const headers = {
            // custom headers from invocation options should precede library options
            ...libraryConfigHeaders,
            ...invocationHeaders,
        };
        const signingServiceInfo = (0, utils_1.parseSigningInfo)(url, {
            amplify,
            apiName,
        });
        utils_1.logger.debug(method, url, headers, `IAM signing options: ${JSON.stringify(signingServiceInfo)}`);
        return (0, transferHandler_1.transferHandler)(amplify, {
            ...apiOptions,
            url,
            method,
            headers,
            abortSignal,
        }, isIamAuthApplicable_1.isIamAuthApplicableForRest, signingServiceInfo);
    }, publicApisAbortController, 'public', // operation Type
    timeout);
};
const get = (amplify, input) => publicHandler(amplify, input, 'GET');
exports.get = get;
const post = (amplify, input) => publicHandler(amplify, input, 'POST');
exports.post = post;
const put = (amplify, input) => publicHandler(amplify, input, 'PUT');
exports.put = put;
const del = (amplify, input) => publicHandler(amplify, input, 'DELETE');
exports.del = del;
const head = (amplify, input) => publicHandler(amplify, input, 'HEAD');
exports.head = head;
const patch = (amplify, input) => publicHandler(amplify, input, 'PATCH');
exports.patch = patch;
